import { render, staticRenderFns } from "./CreateWalletModal.vue?vue&type=template&id=4549051e&scoped=true&"
import script from "./CreateWalletModal.vue?vue&type=script&lang=js&"
export * from "./CreateWalletModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateWalletModal.vue?vue&type=style&index=0&id=4549051e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4549051e",
  null
  
)

export default component.exports